var exports = {
  "k": "xa15a2ab7--ca1ba4--container",
  "N": "xa15a2ab7--ca1ba4--element",
};

module.exports = exports;
